"use strict";

angular.module('rmProgram')
    .factory('Program', require('./program.js'));